export default __webpack_public_path__ + "static/media/mamut_s1.6d1c6f17.png";